(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/store/deposit-slice.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/store/deposit-slice.js');
'use strict';

var _svs$accountservicesR, _svs$accountservicesR2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  paymentTypes
} = svs.accountservicesReact.deposit.constants;
const instantPayInitialState = ((_svs$accountservicesR = svs.accountservicesReact.deposit) === null || _svs$accountservicesR === void 0 || (_svs$accountservicesR = _svs$accountservicesR.data) === null || _svs$accountservicesR === void 0 ? void 0 : _svs$accountservicesR.instantPay) || undefined;
const lastPaymentMethod = svs.components.Storage.browser.get('lastPaymentMethod', 'transactions') || ((_svs$accountservicesR2 = svs.accountservicesReact.deposit) === null || _svs$accountservicesR2 === void 0 || (_svs$accountservicesR2 = _svs$accountservicesR2.data) === null || _svs$accountservicesR2 === void 0 ? void 0 : _svs$accountservicesR2.lastPaymentMethod) || null;
const selectDespositmethod = method => {
  if (Object.values(paymentTypes).includes(method)) {
    return method;
  }
  return lastPaymentMethod;
};
const saveInstantPayToUserSession = instantPay => {
  svs.core.userSession.set('depositInstantPayInfo', instantPay);
};

const getInitialState = () => ({
  selectedDepositMethod: selectDespositmethod(lastPaymentMethod),
  instantPay: instantPayInitialState,
  isDepositAndPay: false,
  amount: ''
});
const depositSlice = RTK.createSlice({
  name: 'deposit',
  initialState: getInitialState(),
  reducers: {
    selectedDepositMethodChange: (state, action) => {
      state.selectedDepositMethod = selectDespositmethod(action.payload);
    },
    instantPayChange: (state, action) => {
      if (typeof action.payload === 'object') {
        state.instantPay = action.payload;
        saveInstantPayToUserSession(_objectSpread({}, state.instantPay));
      }
    },
    instantPayAmountChange: (state, action) => {
      var _state$instantPay;
      if ((_state$instantPay = state.instantPay) !== null && _state$instantPay !== void 0 && _state$instantPay.amount) {
        state.instantPay.amount = action.payload;
        saveInstantPayToUserSession(_objectSpread({}, state.instantPay));
      }
    },
    instantPayClear: state => {
      svs.core.userSession.remove('depositInstantPayInfo');
      state.instantPay = {};
    },
    amountChangeAction: (state, action) => {
      state.amount = action.payload;
    },
    returnUrlChange: (state, action) => {
      state.returnUrl = action.payload;
    },
    accountBalanceChangeAction: (state, action) => {
      state.accountBalance = action.payload;
    },
    clearFormsDataAction: state => {
      state.amount = getInitialState().amount;
    }
  }
});
svs.accountservicesReact.deposit.store.deposit = svs.accountservicesReact.deposit.store.deposit || {};
svs.accountservicesReact.deposit.store.deposit.actions = depositSlice.actions;
svs.accountservicesReact.deposit.store.deposit.reducer = depositSlice.reducer;
svs.accountservicesReact.deposit.store.deposit.initialState = getInitialState();

 })(window);